import { FieldType } from '../../types/Field.type';
export const BusinessSizeRef = {
    priority: Number.MAX_VALUE,
    label: 'fields.enm.business_size.label',
    fallbackLabel: 'business size',
    type: FieldType.Enum,
    options: [
        { key: 'LARGE', label: 'fields.enm.business_size.options.LARGE', fallbackLabel: 'large' },
        { key: 'MEDIUM', label: 'fields.enm.business_size.options.MEDIUM', fallbackLabel: 'medium' },
        { key: 'SMALL', label: 'fields.enm.business_size.options.SMALL', fallbackLabel: 'small' },
    ],
    trackFieldValueWithAnalytics: false,
};
